var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(_vm.isEmailConfirmed)?_c('div',[_c('p',{staticClass:"email-confirmed"},[_vm._v(_vm._s(_vm.$t('login.email_confirmed')))])]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }